import React from "react";

const VisionMission = () => {
  return (
    <section className="w-full bg-[#f5f7fb] py-14 sm:py-20 px-4 sm:px-6 lg:px-16">
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
            About{" "}
            <span className="text-[#f99728]">GrowthLoom Digital</span>
          </h2>
          <p className="text-gray-500 mt-3 text-sm sm:text-base max-w-2xl mx-auto">
            Driving innovation, performance, and growth for modern businesses
          </p>
        </div>

        {/* GRID CARDS */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">

          {/* MISSION */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md border hover:shadow-xl transition duration-300">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#f99728] text-white flex items-center justify-center rounded-full font-bold">
                M
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                Our Mission
              </h3>
            </div>
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              Our mission is to provide innovative and effective digital marketing and web development solutions that help businesses grow, scale, and succeed online.
            </p>
          </div>

          {/* VISION */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md border hover:shadow-xl transition duration-300">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-yellow-500 text-white flex items-center justify-center rounded-full font-bold">
                V
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                Our Vision
              </h3>
            </div>
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              To become a trusted global digital marketing agency known for delivering performance-driven solutions, creative excellence, and long-term business growth.
            </p>
          </div>

        </div>

        {/* WHY CHOOSE */}
        <div className="mt-10 sm:mt-14 bg-gradient-to-r from-[#f99728] to-[#f99728] text-white rounded-2xl p-6 sm:p-10 shadow-lg">

          <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-center">
            Why Choose GrowthLoom Digital?
          </h3>

          <div className="grid sm:grid-cols-2 gap-4 text-sm sm:text-base">

            {[
              "Expert digital marketing professionals",
              "Proven SEO & performance marketing strategies",
              "Custom website development solutions",
              "Transparent reporting & communication",
              "Focus on ROI & measurable business growth",
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white/10 backdrop-blur-md p-4 rounded-lg border border-white/20"
              >
                ✔ {item}
              </div>
            ))}

          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-14">
          <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3">
            Let’s Grow Your Business Online
          </h3>
          <p className="text-gray-500 mb-5 text-sm sm:text-base max-w-2xl mx-auto">
            If you’re looking for a reliable digital marketing agency or web solutions company, GrowthLoom Digital is your trusted partner.
          </p>

          <button className="bg-[#f99728] hover:bg-[#f99728] text-white px-6 sm:px-8 py-3 rounded-lg shadow-md transition text-sm sm:text-base">
            Contact Us Today
          </button>
        </div>

      </div>
    </section>
  );
};

export default VisionMission;